import React, { useEffect, useRef, useState } from 'react'
import $ from "jquery";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import jszip from "jszip";
import { Link } from 'react-router-dom';
const RefereeDetail = () => {


    return (
        <>
            <div className="page-wrapper">
                <div className="page-content p-4">
                    <div className="page-breadcrumb d-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Referee Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Referee Management</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="clud-dtl-main">
                        {/* CLUBS TABLE - PURE STATIC HTML (no JS) */}
                        <div className="card">
                            <div className="back-arrow-new">
                                <a href="/club-management"><i className="bx bx-arrow-back" /></a>
                            </div>
                            <h3>CLUB INFORMATION</h3>
                            <div className="club-logo mb-3">
                                <img src="images/main-page/club.jpg" alt="Riverside FC Logo" />
                            </div>
                            <div className="club-info">
                                <div>
                                    <div className="label">Club Name</div>
                                    <div className="value">Riverside FC</div>
                                </div>
                                <div>
                                    <div className="label">Club Director</div>
                                    <div className="value">Alex Morgan</div>
                                </div>
                                <div>
                                    <div className="label">Email</div>
                                    <div className="value">alex@riverside.com</div>
                                </div>
                                <div>
                                    <div className="label">Contact Number</div>
                                    <div className="value">+1 555 0101</div>
                                </div>
                            </div>
                        </div>
                        {/* TEAMS UNDER THIS CLUB */}
                        <div className="card">
                            <h3>TEAMS UNDER THIS CLUB</h3>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Team logo</th>
                                        <th>TEAM NAME</th>
                                        <th>AGE GROUP</th>
                                        <th>SEASON</th>
                                        <th>COACH</th>
                                        <th>PLAYERS</th>
                                        <th>STATUS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><img src="images/app/team-logo.jpg" alt className="team-logo" /></td>
                                        <td>
                                            Eagles U10
                                        </td>
                                        <td>U-10</td>
                                        <td>Spring 2026</td>
                                        <td>Mike Brown</td>
                                        <td>15</td>
                                        <td><span className="status active">Active</span></td>
                                    </tr>
                                    <tr>
                                        <td><img src="images/app/team-logo.jpg" alt className="team-logo" /></td>
                                        <td>
                                            Eagles U12
                                        </td>
                                        <td>U-12</td>
                                        <td>Spring 2026</td>
                                        <td>Lisa Tan</td>
                                        <td>14</td>
                                        <td><span className="status active">Active</span></td>
                                    </tr>
                                    <tr>
                                        <td><img src="images/app/team-logo.jpg" alt className="team-logo" /></td>
                                        <td>
                                            Eagles U14
                                        </td>
                                        <td>U-14</td>
                                        <td>Spring 2026</td>
                                        <td>-</td>
                                        <td>16</td>
                                        <td><span className="status active">Active</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {/* SCHEDULING REQUEST HISTORY */}
                        <div className="card">
                            <h3>SCHEDULING REQUEST HISTORY</h3>
                            <table>
                                <thead>
                                    <tr>
                                        <th>REQUEST ID</th>
                                        <th>TEAM</th>
                                        <th>SEASON</th>
                                        <th>AGE GROUP</th>
                                        <th>PREFERRED SLOTS</th>
                                        <th>STATUS</th>
                                        <th>MATCHED OPPONENT</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>#REQ-001</td>
                                        <td>Eagles U10</td>
                                        <td>Spring 2026</td>
                                        <td>U-10</td>
                                        <td>Sat 10AM, Sun 4PM</td>
                                        <td><span className="status matched">Matched</span></td>
                                        <td>Lions SC U10</td>
                                    </tr>
                                    <tr>
                                        <td>#REQ-002</td>
                                        <td>Eagles U12</td>
                                        <td>Spring 2026</td>
                                        <td>U-12</td>
                                        <td>Fri 6PM</td>
                                        <td><span className="status pending">Pending</span></td>
                                        <td>-</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>


                </div>
            </div>




        </>
    )
}

export default RefereeDetail